
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Lateral_condyle_fracture_classification',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Orthopaedics/Lateral_condyle_fracture_classification.vue